import React, { Fragment } from 'react'
import DataTable from 'react-data-table-component';
import SearchComponent from '../../_Components/SearchComponent';
import RenderProfilePicture from '../../../../../../_helpers/profile-picture';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';

export default function AddToTeam({ addingToTeam, handleBack, handleAddToTeam }) {

  const columns = [
    {
      name: <Form.Check id='default-checkbox' type='checkbox' />,
      sort: false,
      width: '50px',
      cell: (location) => {
        return <Form.Check 
        id='default-checkbox'
        type='checkbox'
      />
      }
    },
    {
      name: 'LOCATIONS',
      sort: false,
      cell: (location) => {
        return renderLocation(location)
      }
    },
    {
      name: '',
      sort: false,
      cell: (location) => {
        return <span className='text-muted'>
          { location.address }
        </span>
      }
    },
    {
      name: '',
      sort: false,
      cell: (location) => {
        return <div className='w-100 text-center'>
          <span className="badge badge-pill badge-info">{`${location.count} Members`}</span>
        </div>
      }
    },
  ];

  const collection = {
    data: [
      {
        name: 'Lugonia Murrieta',
        type: 'Lugonia Orthopedic',
        count: 4,
        profileUrl: 'https://image.shutterstock.com/image-photo/modern-hospital-style-building-260nw-212251981.jpg',
        address: '9124 Scott Rd., Suite 9B Murrieta, CA 91838'
      },
      {
        name: 'Beaumont Office',
        type: 'Lugonia Orthopedic',
        count: 2,
        profileUrl: 'https://media.istockphoto.com/photos/modern-hospital-building-picture-id1312706413?b=1&k=20&m=1312706413&s=170667a&w=0&h=VRi3w2E1UqvCCcK-nDV6mH7FhDZoTU9MM2QKSom96X4=',
        address: '9182 Beaumont Ave, Suite 304 Beaumont, CA 92193'
      },
      {
        name: 'Redlands Spine Center',
        type: 'Lugonia Orthopedic',
        count: 0,
        profileUrl: 'https://media.gettyimages.com/photos/study-of-architectural-form-05-picture-id173799627?s=612x612',
        address: '1901 Lugonia Ave Redlands, CA 92324'
      },
    ]
  }

  const renderLocation = (location) => {
    return <div className='row w-100'>
      <div className="col-auto">
        <RenderProfilePicture height={30} width={30} image={location.profileUrl} circle cached={false} className='m-auto' />
      </div>
      <div className="col-auto">
        <div className="row">
          <div className="col">
            <div>{location.name}</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <span className='text-muted'>{location.type}</span>
          </div>
        </div>
      </div>
    </div>
  }

  return (
    <Fragment>
      <div className='lead pb-3'>Add To Location Team</div>
      <Alert variant="primary">
        <p className="mb-0">
          Add this user to a location team using the table below. A location team is a group of users that will be forwarded notifications for a location.
        </p>
      </Alert>
      <div className="axs-shadow axs-rounded p-1 mb-3" style={{background: 'white'}}>
        <DataTable
          noHeader
          columns={columns}
          data={collection.data}
          subHeader
          subHeaderComponent={
            <SearchComponent placeholder='Search Locations'>
              <div className="form-group">
                <div className='d-flex'>
                  <Button disabled={addingToTeam} onClick={handleBack} className='mr-4 px-4' variant='outline-primary'>Cancel</Button>
                  <Button disabled={addingToTeam} onClick={handleAddToTeam} className='px-5' variant='success'>
                    { addingToTeam ? <Spinner size='sm' animation='border'/> : 'Add to Location(s)'}
                  </Button>
                </div>
              </div>
            </SearchComponent>
          }
          // onChangePage={page => {
          //   const queryParams = queryString.parse(this.props.location.search);

          //   const searchParams = {
          //     firstName: queryParams.firstName || '',
          //     lastName: queryParams.lastName || ''
          //   };

          //   dispatch(userActions.setPage(page));
          //   dispatch(userActions.retrieveUsers(page, searchParams))
          // }}
          pagination={true}
          paginationServer={true}
          // paginationTotalRows={total}
          paginationRowsPerPageOptions={[15]}
          paginationPerPage={3}
          customStyles={{ 
            cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
            headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
            subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
          }}
        />
      </div>
    </Fragment>
  )
}
